<template>
  <div>
    <notifications />
    <div class="row justify-content-center" v-if="!this.$root.loading">
      <div class="col-xl-7 col-lg-8">
        <form v-on:submit.prevent="requestBrochure">
          <div class="form-group">
            <label>Title</label>
            <select class="form-control" v-model="brochureRequest.title">
              <option
                v-for="(option, index) in titleOptions"
                :key="index"
                :value="option"
                >{{ option }}</option
              >
            </select>
          </div>

          <div class="form-group">
            <label for="first_name">First name:</label>
            <input
              type="text"
              class="form-control"
              id="first_name"
              aria-describedby="first_name"
              placeholder="e.g. John"
              required
              name="first_name"
              v-model="brochureRequest.first_name"
            />
          </div>

          <div class="form-group">
            <label for="last_name">Last name:</label>
            <input
              type="text"
              class="form-control"
              id="last_name"
              aria-describedby="last_name"
              placeholder="e.g. Smith"
              required
              name="last_name"
              v-model="brochureRequest.last_name"
            />
          </div>

          <div class="form-group">
            <label for="email">Email:</label>
            <input
              type="email"
              class="form-control"
              id="email"
              aria-describedby="email"
              placeholder="e.g. john.smith@example.com"
              name="email"
              v-model="brochureRequest.email"
            />
          </div>

          <div class="form-group">
            <label for="street_address">Street address:</label>
            <input
              type="text"
              class="form-control"
              id="street_address"
              aria-describedby="street_address"
              required
              name="street_address"
              v-model="brochureRequest.street_address"
            />
          </div>

          <div class="form-group">
            <label for="address_line_2">Address line 2:</label>
            <input
              type="text"
              class="form-control"
              id="address_line_2"
              aria-describedby="address_line_2"
              name="address_line_2"
              v-model="brochureRequest.address_line_2"
            />
          </div>

          <div class="form-group">
            <label for="town">Town:</label>
            <input
              type="text"
              class="form-control"
              id="town"
              aria-describedby="town"
              required
              name="town"
              v-model="brochureRequest.town"
            />
          </div>

          <div class="form-group">
            <label for="county">County:</label>
            <input
              type="text"
              class="form-control"
              id="county"
              aria-describedby="county"
              name="county"
              v-model="brochureRequest.county"
            />
          </div>

          <div class="form-group">
            <label for="postcode">Post code:</label>
            <input
              type="text"
              class="form-control"
              id="postcode"
              aria-describedby="postcode"
              required
              name="postcode"
              v-model="brochureRequest.postcode"
            />
          </div>

          <div class="form-group">
            <label>Brochures required:</label>
            <div
              class="custom-control custom-checkbox"
              v-for="(brochure, index) in brochures"
              :key="index"
            >
              <input
                type="checkbox"
                :id="'custom-checkbox-' + brochure.id"
                name="brochures"
                class="custom-control-input"
                :value="brochure.id"
                v-model="brochureRequest.brochure_selected"
              />
              <label
                class="custom-control-label"
                :for="'custom-checkbox-' + brochure.id"
                >{{ brochure.brochure_name }}</label
              >
            </div>
          </div>

          <div class="form-group">
            <label for="where">Where did you hear about us?</label>
            <select class="form-control" v-model="brochureRequest.affiliate">
              <option
                v-for="(affiliate, index) in affiliates"
                :key="index"
                :value="affiliate.id"
                >{{ affiliate.name }}</option
              >
            </select>
          </div>

          <div class="mb-3 row">
            <button class="btn btn-primary">Send Request</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BrochureRequestForm",
  data() {
    return {
      brochures: [],
      affiliates: [],
      brochureRequest: {
        title: "",
        first_name: "",
        last_name: "",
        email: "",
        street_address: "",
        address_line_2: "",
        town: "",
        county: "",
        postcode: "",
        brochure_selected: [],
        affiliate: "",
      },
      titleOptions: ["Mr", "Mrs", "Miss", "Ms", "Lady", "Sir", "Dr"],
    };
  },
  created() {
    this.getBrochures();
    this.getAffiliates();
  },
  methods: {
    getBrochures() {
      this.$root.loading = true;
      axios
        .get(this.$root.$api + "brochure-list?type=active")
        .then((res) => res.data)
        .then((response) => {
          this.brochures = response.data;
          if (this.brochures.length > 0) {
            this.brochures = this.brochures.slice().sort((a, b) => {
              return a.brochure_name.localeCompare(b.brochure_name);
            });
          }
          this.$root.loading = false;
        });
    },
    getAffiliates() {
      this.$root.loading = true;
      axios
        .get(this.$root.$api + "affiliate-list?type=active")
        .then((res) => res.data)
        .then((response) => {
          this.affiliates = response.data;
          if (this.affiliates.length > 0) {
            this.affiliates = this.affiliates.slice().sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
          }
          this.$root.loading = false;
        });
    },
    requestBrochure() {
      this.$root.loading = true;
      axios
        .post(this.$root.$api + "request-brochure", this.brochureRequest)
        .then((res) => res.data)
        .then((response) => {
          this.$root.loading = false;
          if (response.success) {
            this.$notify({
              type: "success",
              title: response.message,
            });
            this.brochureRequest = {
              title: "",
              first_name: "",
              last_name: "",
              email: "",
              street_address: "",
              address_line_2: "",
              town: "",
              county: "",
              postcode: "",
              brochure_selected: [],
              affiliate: "",
            };
          } else if (response.errors) {
            this.$notify({
              type: "error",
              title: response.message,
            });
          }
        })
        .catch((error) => {
          this.$root.loading = false;
          console.log(error.response, "sasa");
          if (error.response.data.message) {
            this.$notify({
              type: "error",
              title: error.response.data.message,
            });
          }
        });
    },
  },
};
</script>
